import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setDropDownArray } from '../../redux/dropdownSlice';
import { genreList } from '../../services/api';
export default ()=> {
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const dispatch = useDispatch();
    //Get approver dropdown array from Server
    const [genre, setgenre] = useState(dropdownReducer.genre);
    const { data: genreData, isLoading: genreLoading, refetch: refetchgenre } = useQuery( ["genre"],
                                               () => genreList(),
                                               { enabled: genre.length == 0, retry: false }
                                            )
    useEffect(() => {
        if (genreData) {
           dispatch(setDropDownArray({genre: genreData?.data?.genre }))
          // setgenre(genreData?.data?.genre)
        }
    }, [genreData])

    const selectedGenre = (id) => {
        if (dropdownReducer.genre.length > 0 && dropdownReducer.genre.find((item)=> item.id == id) ) {
            return dropdownReducer.genre.find((item)=> item.id == id)
        } else {
            return {}
        }
    };

  
    return [dropdownReducer.genre, selectedGenre]
    
}